/* libs */
import React from "react";
import PropTypes from "prop-types";
import { FontPicker, CheckBox, ColorPicker, NumberInput, ShadowInput } from "../../../../../components/shared/Forms";
import { renderFields } from "./helper";

const Font = ({ state, checkForEmptyValues, primaryStatePath, currentStatePath, hideFieldRowBorder = false }) => {
	const fields = [
		<FontPicker field="family" id="family" placeholder="Font Family" themeBuilderInputType="FontPicker" />,
		<NumberInput field="size" id="size" placeholder="Font Size" themeBuilderInputType="NumberInput" />,
		<NumberInput
			field="lineHeight"
			id="lineHeight"
			placeholder="Line Height"
			themeBuilderInputType="NumberInput"
		/>,
		<ColorPicker field="color" id="color" placeholder="Font Color" themeBuilderInputType="ColorPicker" />,
		<CheckBox field="bold" id={`${state}-bold`} label="Bold" themeBuilderInputType="CheckBox" />,
		<CheckBox field="italic" id={`${state}-italic`} label="Italic" themeBuilderInputType="CheckBox" />,
		<CheckBox field="underline" id={`${state}-underline`} label="Underline" themeBuilderInputType="CheckBox" />,
		<CheckBox field="uppercase" id={`${state}-uppercase`} label="Uppercase" themeBuilderInputType="CheckBox" />,
		<NumberInput
			field="letterSpacing"
			id="letterSpacing"
			placeholder="Letter Spacing"
			themeBuilderInputType="NumberInput"
		/>,
		<ShadowInput
			field="textShadow"
			id="textShadow"
			type="text"
			placeholder="Text Shadow"
			themeBuilderInputType="ShadowInput"
		/>,
	];

	return hideFieldRowBorder ? (
		<React.Fragment>{renderFields(fields)}</React.Fragment>
	) : (
		<React.Fragment>
			{checkForEmptyValues(`${primaryStatePath}.font`, `${currentStatePath}.font`, fields)}
		</React.Fragment>
	);
};

Font.propTypes = {
	state: PropTypes.string.isRequired,
	checkForEmptyValues: PropTypes.func.isRequired,
	primaryStatePath: PropTypes.string.isRequired,
	currentStatePath: PropTypes.string.isRequired,
};

export default Font;
